import { toJS } from 'mobx';
import isEqual from 'lodash/isEqual';
import getSortableColumn from '../utils/getSortableColumn';
import { ADVANCED_SORT_TYPES } from '../constants';

export const isExistingAdvancedSort = (column, existingAdvancedSort = {}) => {
    column = getSortableColumn(column);
    const { property, code, key, sortKey = '' } = column.data || ({} as any);

    const advancedSort = {
        type: ADVANCED_SORT_TYPES[property],
        code,
        key: sortKey,
        value: key,
    };

    existingAdvancedSort = toJS(existingAdvancedSort);
    delete (existingAdvancedSort as any).direction;

    return isEqual(advancedSort, existingAdvancedSort);
};

export default isExistingAdvancedSort;



// WEBPACK FOOTER //
// ./src/utils/isExistingAdvancedSort.ts